import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Locale } from '@utils/models';
import { AppContextActions, detectRegionFromContext } from '../localization/duck';

export function AppInitializer() {
  const dispatch = useDispatch();
  useEffect(() => {
    const region = detectRegionFromContext();
    const initialContext = {
      displayName: 'User',
      region,
      locale: Locale.enGB,
    };
    dispatch(AppContextActions.initialize(initialContext));
  }, [dispatch]);
  return null;
}
